import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param {object} props - Props.
 * @param props.teamAbbreviation
 * @param props.className
 * @param props.side
 * @param props.type
 * @param props.providerId
 * @returns {JSX.Element} Component.
 */
export const TeamWatermarkBackground = ({
    teamAbbreviation,
    className = '',
    side = 'right',
    type = '',
    providerId = ''
}) => {
    let teamAbbr = '';
    const prefix = PULSE.app.common.team
        .getAFLWSpecificIcons()
        .includes(providerId)
        ? 'aflw-'
        : '';

    if (
        typeof teamAbbreviation !== 'undefined' &&
        teamAbbreviation !== null &&
        teamAbbreviation.length > 0
    ) {
        teamAbbr = teamAbbreviation.toLowerCase();
    } else {
        teamAbbr = PULSE.app.common.team.getTeamAbbr(providerId) || 'afl';
    }

    return (
        <div
            className={`stats-team-watermark-background stats-team-watermark-background--${
                teamAbbr ? teamAbbr.toLowerCase() : 'afl'
            } stats-team-watermark-background--${side}${
                type ? `-${type}` : ''
            } ${className}`}
        >
            <div className="stats-team-watermark-background__overlay"></div>
            <div
                className="stats-team-watermark-background__watermark"
                style={{
                    backgroundImage: `url('${
                        PULSE.app.environment.watermarksPath
                    }${
                        teamAbbr
                            ? `${teamAbbr.toLowerCase()}-${prefix}${side}-dark.png`
                            : `afl-${side}-colour.png`
                    }')`
                }}
            />
        </div>
    );
};

TeamWatermarkBackground.propTypes = {
    teamAbbreviation: PropTypes.string,
    className: PropTypes.string,
    side: PropTypes.string,
    type: PropTypes.string,
    providerId: PropTypes.string
};
